import { TextInput } from 'react-native';
/**
 * 按钮类型背景颜色的type
 */
export enum ButtonType {
  'default' = '#ffffff',
  'primary' = '#1989fa',
  'success' = '#07c160',
  'warning' = '#ee0a24',
  'danger' = '#ff976a',
}
/**
 * Field ref的ts类型
 */
export type FieldRefType = Pick<
TextInput,
 'clear' | 'blur' | 'focus' | 'isFocused'
>;
